import React from "react";
import "../styles/forms.css";
import {
  saveIdiomas,
  getPerfil,
  getDataFrm,
  deleteIdiomas,
} from "../requests/req_perfil";
import { Col, FormGroup, Button, UncontrolledTooltip } from "reactstrap";
import { notifica, show_ldr } from "../requests/utils";
import Swal from "sweetalert2";
import {
  getIdiomas,
  getNivelesConocimiento,
} from "../requests/CatalogosGenerales";
import { postInsertarIdioma } from "./../requests/PerfilCandidato";

export default class FrmIdiomas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      idiomas: null,
      edit: false,
      idiomaSelect: null,
      idiomasLi: [],
      nivelesConocimiento: [],
    };
    this.editar = this.editar.bind(this);
    this.agregar = this.agregar.bind(this);
    this.eliminar = this.eliminar.bind(this);
    this.llenaForm = this.llenaForm.bind(this);
    this.resultSave = this.resultSave.bind(this);
    this.guardarInf = this.guardarInf.bind(this);
    this.generaFilas = this.generaFilas.bind(this);
    this.asignaValores = this.asignaValores.bind(this);
    this.editCloseForm = this.editCloseForm.bind(this);
    this.validarCampos = this.validarCampos.bind(this);
  }

  componentDidMount() {
    if (this.props.datos !== null) {
      this.setState({ idiomas: this.props.datos });
      if (localStorage.getItem("frmIdms") != null) {
        this.editCloseForm(localStorage.getItem("frmIdms"));
      }
    }
    getIdiomas().then((res) => {
      this.setState({ idiomasLi: res });
    });
    getNivelesConocimiento().then((res) => {
      this.setState({ nivelesConocimiento: res });
    });
  }
  componentWillUnmount() {
    this._isMounted = false;
    var json = getDataFrm(".frmIdms");
    if (
      (parseInt(JSON.parse(json).IdIdioma) !== 0 ||
        parseInt(JSON.parse(json).IdNivelEscrito) !== "0" ||
        parseInt(JSON.parse(json).IdNivelOral) !== "0" ||
        parseInt(JSON.parse(json).IdNivelLectura) !== "0") &&
      this.state.edit
    )
      localStorage.setItem("frmIdms", json);
    else localStorage.removeItem("frmIdms");
  }

  componentDidUpdate(prevProps) {
    if (prevProps.datos !== this.props.datos) {
      this.setState({ idiomas: this.props.datos });
    }
  }
  editCloseForm(data) {
    if (data != null) {
      var Items = JSON.parse(data);
      var dv = document.getElementById("dv_AgregaIdioma"),
        btnSv = document.getElementById("img_sv_Idi"),
        btn = document.getElementById("btn_idi_add"),
        chk = document.getElementById("chkElmnr_Idm");
      chk.checked = false;
      btnSv.classList.remove("Hide_All");
      btn.classList.add("Hide_All");
      dv.classList.remove("Hide_All");

      var IdIdioma = document.getElementById("IdIdioma");
      var idNivelEscrito = document.getElementById("idNivelEscrito");
      var idNivelOral = document.getElementById("idNivelOral");
      var idNivelLectura = document.getElementById("idNivelLectura");
      IdIdioma.value = Items.IdIdioma != null ? Items.IdIdioma : "0";
      idNivelEscrito.value =
        Items.IdNivelEscrito != null ? Items.IdNivelEscrito : "0";
      idNivelOral.value = Items.IdNivelOral != null ? Items.IdNivelOral : "0";
      idNivelLectura.value =
        Items.IdNivelLectura != null ? Items.IdNivelLectura : "0";
    }
  }
  agregar(e) {
    var elm = e.target,
      btn = elm.tagName === "IMG" ? elm.parentElement : elm,
      dv = document.getElementById("dv_AgregaIdioma"),
      btnSv = document.getElementById("img_sv_Idi"),
      chk = document.getElementById("chkElmnr_Idm");
    chk.checked = false;
    btnSv.classList.remove("Hide_All");
    btn.classList.add("Hide_All");
    dv.classList.remove("Hide_All");
    this.setState({ edit: false });
  }

  eliminar(e) {
    Swal.fire({
      title: "¿Estas seguro que deseas eliminar?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
    }).then((result) => {
      if (result.value) {
        deleteIdiomas(e);
        this.setState({ edit: false });

        getPerfil((p) => this.asignaValores(p));
        for (var i = 0; i < this.props.datos.length; i++) {
          if (this.props.datos[i].IdIdioma === parseInt(e.IdIdioma, 10)) {
            this.props.datos.splice(i, 1);
          }
        }

        var btnrefresh = document.getElementById("btnrefresh");
        if (btnrefresh) btnrefresh.click();
        const { handleUpdate } = this.props;
        handleUpdate && handleUpdate();
      }
    });
  }

  editar(e) {
    this.setState({ edit: true });
    var chk = document.getElementById("chkElmnr_Idm"),
      dv = document.getElementById("dv_AgregaIdioma"),
      btn = document.getElementById("btn_idi_add"),
      grd = document.getElementById("img_sv_Idi"),
      elm = e.target,
      td = elm.parentElement,
      tr = td.parentElement,
      id = tr.getAttribute("ididioma"),
      fila = this.state.idiomas.filter(
        (i) => i.idIdioma === parseInt(id, 10)
      )[0];
    btn.classList.add("Hide_All");
    grd.classList.remove("Hide_All");
    dv.classList.remove("Hide_All");
    chk.checked = false;
    this.setState({ idiomaSelect: fila });
  }

  llenaForm(fila) {
    for (var key in fila) {
      var inp = document.getElementsByName(key);
      if (inp[0] !== undefined) {
        inp[0].value = fila[key];
      }
    }
  }

  generaFilas(dts) {
    var imgDelete = window.origin + "/images/icon_delete_1.png",
      imgEdit = window.origin + "/images/icon_edit_1.png";
    if (!dts) return null;
    return dts.map((d, index) => {
      return (
        <tr ididioma={d.idIdioma} key={index}>
          <td>{d.idioma}</td>
          <td>{d.nivelOral}</td>
          <td>{d.nivelEscrito}</td>
          <td>{d.nivelLectura}</td>
          <td>
            <img
              src={imgEdit}
              alt=""
              onClick={(e) => this.editar(e)}
              id={"img_edit" + d.idioma}
            />
            <UncontrolledTooltip
              placement="top"
              target={"img_edit" + d.idioma}
            >
              Editar
            </UncontrolledTooltip>
            <img
              src={imgDelete}
              alt=""
              onClick={(e) => this.eliminar(d)}
              id={"img_elimin" + d.idioma}
            />
            <UncontrolledTooltip
              placement="top"
              target={"img_elimin" + d.idioma}
            >
              Eliminar
            </UncontrolledTooltip>
          </td>
        </tr>
      );
    });
  }

  guardarInf(e) {
    if (!this.validarCampos()) return;
    const { handleUpdate } = this.props;

    if (this.state.edit === false) {
      var json = getDataFrm(".frmIdms");
      var contador = 0;
      var pJSon = JSON.parse(json);

      this.state.idiomas.map((valor) => {
        if (valor.IdIdioma === parseInt(pJSon.IdIdioma)) {
          return contador++;
        }
        return null;
      });

      if (contador === 0) {
        show_ldr(true);
        let parsedData = {
          IdCandidato: pJSon.idCandidato,
          IdIdioma: pJSon.IdIdioma,
          IdNivelEscrito: pJSon.IdNivelEscrito,
          IdNivelOral: pJSon.IdNivelOral,
          IdNivelLectura: pJSon.IdNivelLectura,
        };
        postInsertarIdioma(parsedData).then((res) => {
          show_ldr(false);
          getPerfil((p) => this.asignaValores(p));
          handleUpdate && handleUpdate();

          var btnrefresh = document.getElementById("btnrefresh");
          if (btnrefresh) btnrefresh.click();
        });
      } else {
        notifica("warning", "Ya se encuentra registrado el idioma", "Error");
      }
    } else {
      saveIdiomas(
        (s) => this.resultSave(s),
        this.state.idiomas,
        this.state.edit
      );
    }
    var chk = document.getElementById("chkElmnr_Idm"),
      dv = document.getElementById("dv_AgregaIdioma"),
      btn = document.getElementById("btn_idi_add"),
      grd = document.getElementById("img_sv_Idi");
    var IdIdioma = document.getElementById("IdIdioma");
    var idNivelEscrito = document.getElementById("idNivelEscrito");
    var idNivelOral = document.getElementById("idNivelOral");
    var idNivelLectura = document.getElementById("idNivelLectura");
    IdIdioma.value = "0";
    idNivelEscrito.value = "0";
    idNivelOral.value = "0";
    idNivelLectura.value = "0";
    btn.classList.remove("Hide_All");
    grd.classList.add("Hide_All");
    dv.classList.add("Hide_All");
    chk.checked = false;
    this.setState({ edit: false });
    getPerfil((p) => this.asignaValores(p));
    var btnrefresh = document.getElementById("btnrefresh");
    if (btnrefresh) btnrefresh.click();
  }

  validarCampos() {
    var IdIdioma = document.getElementById("IdIdioma");
    var idNivelEscrito = document.getElementById("idNivelEscrito");
    var idNivelOral = document.getElementById("idNivelOral");
    var idNivelLectura = document.getElementById("idNivelLectura");
    let message = [];

    if (parseInt(IdIdioma.value) === 0 || IdIdioma.value == null) {
      message.push("Debe de indicar un idioma.");
    }
    if (parseInt(idNivelEscrito.value) === 0 || idNivelEscrito.value == null) {
      message.push("Debe de indicar el nivel escrito");
    }
    if (parseInt(idNivelOral.value) === 0 || idNivelOral.value == null) {
      message.push("Debe de indicar el nivel oral.");
    }
    if (parseInt(idNivelLectura.value) === 0 || idNivelLectura.value == null) {
      message.push("Debe de indicar el nivel de lectura.");
    }

    if (message.length === 1) {
      notifica("warning", message[0], "Alerta!");
      return false;
    } else if (message.length > 1) {
      notifica("warning", "Todos los campos son obligatorios.", "Alerta!");
      return false;
    } else {
      return true;
    }
  }
  asignaValores(res) {
    if (res.code === 0) {
      var tbls = res.data[0];

      this.setState({
        datos: tbls.Tabla4,
      });
      var btnrefresh = document.getElementById("btnrefresh");
      if (btnrefresh) btnrefresh.click();
    }
  }

  resultSave(res) {
    if (res.ok) {
      const { handleUpdate } = this.props;
      handleUpdate && handleUpdate();
      notifica("success", res.data, "");
    } else {
      notifica("error", res.data || "Error desconocido", "Error");
    }
  }

  render() {
    const { datos } = this.props;
    return (
      <div className="APL_Frm_dv">
        <FormGroup
          id="dv_AgregaIdioma"
          className="Hide_All dv_Form_New_Edit"
          row
        >
          <Col sm={3} md={3} lg={3}>
            {" "}
            <label className="lbl_md">
              Idioma:<span style={{ color: "red" }}>*</span>
            </label>{" "}
          </Col>
          <Col sm={9} md={9} lg={9}>
            <select
              className="frm frmIdms"
              datsvfrm="IdIdioma"
              name="IdIdioma"
              id="IdIdioma"
              value={
                this.state.idiomaSelect ? this.state.idiomaSelect.idIdioma : "0"
              }
              onChange={(x) =>
                this.setState({ idiomaSelect: { idIdioma: x.value } })
              }
            >
              <option value="0">Selecciona...</option>
              {this.state.idiomasLi.map((item, index) => {
                return (
                  <option value={item.value} key={index}>
                    {item.label}
                  </option>
                );
              })}
            </select>
          </Col>
          <Col sm={3} md={3} lg={3}>
            {" "}
            <label className="lbl_md">
              Nivel Escrito:<span style={{ color: "red" }}>*</span>
            </label>{" "}
          </Col>
          <Col sm={3} md={3} lg={3}>
            <select
              className="frm frmIdms"
              datsvfrm="IdNivelEscrito"
              name="idNivelEscrito"
              id="idNivelEscrito"
              value={
                this.state.idiomaSelect
                  ? this.state.idiomaSelect.idNivelEscrito
                  : "0"
              }
              onChange={(x) =>
                this.setState({ idiomaSelect: { idNivelEscrito: x.value } })
              }
            >
              <option value="0">Selecciona...</option>
              {this.state.nivelesConocimiento.map((item, index) => {
                return (
                  <option value={item.value} key={index}>
                    {item.label}
                  </option>
                );
              })}
            </select>
          </Col>
          <Col sm={3} md={3} lg={3}>
            <label className="lbl_md">
              Nivel Oral:<span style={{ color: "red" }}>*</span>
            </label>{" "}
          </Col>
          <Col sm={3} md={3} lg={3}>
            <select
              className="frm frmIdms"
              datsvfrm="IdNivelOral"
              name="idNivelOral"
              id="idNivelOral"
              value={
                this.state.idiomaSelect
                  ? this.state.idiomaSelect.idNivelOral
                  : "0"
              }
              onChange={(x) =>
                this.setState({ idiomaSelect: { idNivelOral: x.value } })
              }
            >
              <option value="0">Selecciona...</option>
              {this.state.nivelesConocimiento.map((item, index) => {
                return (
                  <option value={item.value} key={index}>
                    {item.label}
                  </option>
                );
              })}
            </select>
          </Col>
          <Col sm={3} md={3} lg={3}>
            <label className="lbl_md">
              Nivel Lectura:<span style={{ color: "red" }}>*</span>
            </label>{" "}
          </Col>
          <Col sm={3} md={3} lg={3}>
            <select
              className="frm frmIdms"
              datsvfrm="IdNivelLectura"
              name="idNivelLectura"
              id="idNivelLectura"
              value={
                this.state.idiomaSelect
                  ? this.state.idiomaSelect.idNivelLectura
                  : "0"
              }
              onChange={(x) =>
                this.setState({ idiomaSelect: { idNivelLectura: x.value } })
              }
            >
              <option value="0">Selecciona...</option>
              {this.state.nivelesConocimiento.map((item, index) => {
                return (
                  <option value={item.value} key={index}>
                    {item.label}
                  </option>
                );
              })}
            </select>
            <input
              className="frm frmIdms Hide_All"
              datsvfrm="eliminar"
              id="chkElmnr_Idm"
              type="checkbox"
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={9} md={9} lg={9}></Col>
          <Col sm={3} md={3} lg={3}>
            <Button
              outline
              color="success"
              className="btn_exp_add"
              id="btn_idi_add"
              ididioma={0}
              onClick={(e) => this.agregar(e, false)}
            >
              <img
                src={window.origin + "/images/icon_add_2.png"}
                className="img_edit"
                alt="Agregar"
              />
              Agregar Idioma
            </Button>
            <Button
              outline
              color="info"
              className="btn_exp_add Hide_All"
              alt="Guardar"
              id="img_sv_Idi"
              ididioma={0}
              onClick={(e) => this.guardarInf(e)}
            >
              <img
                src={window.origin + "/images/icon_save_2.png"}
                className="img_edit"
                alt="Icon Save"
              />
              Guardar Cambios
            </Button>

            <UncontrolledTooltip placement="right" target="img_sv_Idi">
              Guardar Cambios
            </UncontrolledTooltip>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={12} md={12} lg={12} id="dvDetalle">
            <table className="tbl_idioma">
              <thead>
                <tr>
                  <th>Idioma</th>
                  <th>Oral</th>
                  <th>Escrito</th>
                  <th>Lectura</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody id="tbod_idiomas">{this.generaFilas(datos)}</tbody>
            </table>
          </Col>
        </FormGroup>
      </div>
    );
  }
}
